(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("quick-pivot", [], factory);
	else if(typeof exports === 'object')
		exports["quick-pivot"] = factory();
	else
		root["quick-pivot"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(2);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(37);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(38);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _logic = __webpack_require__(42);
	
	var _progressiveDiscovery = __webpack_require__(91);
	
	var _filtering = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pivot = function () {
	
	  /**
	   * instantiates the Pivot class
	   * @param {Array<Array|Object>} data
	   * @param {Array<string>} rows Rows to pivot on
	   * @param {Array<string>} cols Cols to pivot on
	   * @param {string} agg Aggregation category
	   * @param {string} type Aggregation type, enumerated value
	   * @param {string} header Table header (displayed at hte top left)
	   * @param {Function} custom sort function. will skip sort stage if equal to () => {}
	   * @param {Function} columnSortFunc custom sort function for the columns
	   * @returns {Object} instantiated pivot object
	  */
	  function Pivot(data, rows, cols, agg, type, header, sortFunc, columnSortFunc) {
	    (0, _classCallCheck3.default)(this, Pivot);
	
	    if (!data) this.originalData = {};else {
	      data = (0, _logic.fixDataFormat)(data, rows, sortFunc);
	      this.columnSortFunc = columnSortFunc;
	      this.originalArgs = { data: data, rows: rows, cols: cols, agg: agg, type: type, header: header };
	      this.originalData = (0, _logic.tableCreator)(data, rows, cols, agg, type, header, this.columnSortFunc);
	      this.uniqueValues = (0, _filtering.createUniqueValues)(data);
	    }
	
	    this.data = this.originalData;
	    this.collapsedRows = {};
	  }
	
	  /**
	   * Creates a new pivot object based on the new arguments
	   * @param {Array<Array|Object>} data
	   * @param {Array<string>} rows Rows to pivot on
	   * @param {Array<string>} cols Cols to pivot on
	   * @param {string} agg Aggregation category
	   * @param {string} type Aggregation type, enumerated value
	   * @param {string} header Table header (displayed at hte top left)
	   * @param {boolean} isFiltering If the method is being called by the filter method
	   * @param {Function} custom sort function. will skip sort stage if equal to () => {}
	   * @param {Function} columnSortFunc custom sort function for the columns
	   * @returns {Object} instantiated pivot object
	  */
	
	
	  (0, _createClass3.default)(Pivot, [{
	    key: 'update',
	    value: function update(data, rows, cols, agg, type, header, isFiltering, sortFunc, columnSortFunc) {
	      data = (0, _logic.fixDataFormat)(data, rows, sortFunc);
	      /** if update isn't being used by filter, need to reset the original arguments */
	      if (!isFiltering) {
	        this.originalArgs = { data: data, rows: rows, cols: cols, agg: agg, type: type, header: header };
	        this.uniqueValues = (0, _filtering.createUniqueValues)(data);
	      }
	
	      this.columnSortFunc = columnSortFunc;
	      this.originalData = (0, _logic.tableCreator)(data, rows, cols, agg, type, header, this.columnSortFunc);
	      this.data = this.originalData;
	      this.originalArgs.data = data;
	      this.collapsedRows = {};
	
	      return this;
	    }
	
	    /**
	     * Collapses the given header row
	     * @param {number} rowNum The header row to collapse
	     * @returns {Object} pivot object
	    */
	
	  }, {
	    key: 'collapse',
	    value: function collapse(rowNum) {
	      // already collapsed
	      if (this.collapsedRows[this.data.table[rowNum].row]) {
	        return this;
	      }
	
	      var returnedData = (0, _progressiveDiscovery.collapse)(rowNum, this.data);
	
	      if (returnedData.collapsed) {
	        this.collapsedRows[this.data.table[rowNum].row] = returnedData.collapsed;
	      }
	      this.data = returnedData.uncollapsed;
	
	      return this;
	    }
	
	    /**
	     * Expands the given header row
	     * @param {number} rowNum The header row to expand
	     * @returns {Object} pivot object
	    */
	
	  }, {
	    key: 'expand',
	    value: function expand(rowNum) {
	      this.data = (0, _progressiveDiscovery.expand)(rowNum, this.data, this.collapsedRows[this.data.table[rowNum].row]);
	      delete this.collapsedRows[this.data.table[rowNum].row];
	
	      return this;
	    }
	
	    /**
	     * Collapses all header rows
	     * @returns {Object} pivot object
	    */
	
	  }, {
	    key: 'collapseAll',
	    value: function collapseAll() {
	      var _this = this;
	
	      this.data.table.map(function (row, rowNum) {
	        return row.type === 'rowHeader' ? rowNum : null;
	      }).filter(function (rowNum) {
	        return rowNum !== null;
	      }).reverse().forEach(function (rowNum) {
	        _this.collapse(rowNum);
	      });
	
	      return this;
	    }
	
	    /**
	     * Expands all header rows
	     * @returns {Object} pivot object
	    */
	
	  }, {
	    key: 'expandAll',
	    value: function expandAll() {
	      var _this2 = this;
	
	      this.data.table.map(function (row, rowNum) {
	        return row.type === 'rowHeader' ? rowNum : null;
	      }).filter(function (rowNum) {
	        return rowNum !== null;
	      }).reverse().forEach(function (rowNum) {
	        _this2.expand(rowNum);
	      });
	
	      return this;
	    }
	
	    /**
	     * Toggles the given header row
	     * @param {number} rowNum The header row to toggle the collapsed/expanded state
	     * @returns {Object} pivot object
	    */
	
	  }, {
	    key: 'toggle',
	    value: function toggle(rowNum) {
	      if (this.data.table[rowNum].row in this.collapsedRows) this.expand(rowNum);else this.collapse(rowNum);
	
	      return this;
	    }
	
	    /**
	     * Returns the data for a selected row
	     * @param {number} rowNum
	     * @returns {Object} the data for a selected row
	    */
	
	  }, {
	    key: 'getData',
	    value: function getData(rowNum) {
	      if (!this.data.table[rowNum]) return null;
	      if (this.collapsedRows[this.data.table[rowNum].row]) {
	        return this.collapsedRows[this.data.table[rowNum].row].rawData;
	      }
	
	      return this.originalData.rawData[this.data.table[rowNum].row];
	    }
	
	    /**
	     * Gets all the unique values for a given field name
	     * @param {string} fieldName
	     * @returns {!Array<string>}
	    */
	
	  }, {
	    key: 'getUniqueValues',
	    value: function getUniqueValues(fieldName) {
	      /** if the field name does not exist, return empty []*/
	      if (this.uniqueValues[fieldName]) {
	        /** uniqueValues stores unique values in an object so it can be quickly constructed */
	        return (0, _keys2.default)(this.uniqueValues[fieldName]);
	      }
	
	      return [];
	    }
	
	    /**
	     * Filters the data based on provided parameters
	     * @param {string|function} fieldName Either the field to filter on or a callback function
	     * @param {Array<string>} filterValues Values in field to filter
	     * @param {?string} filterType Enumerated string either 'include' or 'exclude'
	     * @returns {Object} Returns the pivot object so it is chainable
	    */
	
	  }, {
	    key: 'filter',
	    value: function filter(fieldName, filterValues, filterType) {
	      var _this3 = this;
	
	      /** check that the parameters are of allowed type */
	      if (typeof fieldName === 'function' || typeof fieldName === 'string' && Array.isArray(filterValues)) {
	        /** filter out the data set based on the parameters*/
	        var filteredData = (0, _filtering.filter)(this.originalArgs.data, fieldName, filterValues, filterType);
	        /** collect the original arguments provided */
	        var _originalArgs = this.originalArgs,
	            rows = _originalArgs.rows,
	            cols = _originalArgs.cols,
	            agg = _originalArgs.agg,
	            type = _originalArgs.type,
	            header = _originalArgs.header;
	
	        /**
	         * get the current rows that are collapsed in reverse because we
	         * will recollapse them from bottom to top to ensure nested collapses
	         * note: can't use numbered rows unfortunately because when we filter
	         * the data, the row numbers will change
	        */
	
	        var collapsedRowKeys = (0, _keys2.default)(this.collapsedRows).reverse();
	        var collapsedRows = collapsedRowKeys.map(function (num) {
	          return _this3.originalData.table[num].value[0];
	        });
	
	        /** update the pivot table with the new filtered data */
	        this.update(filteredData, rows, cols, agg, type, header, true, this.columnSortFunc);
	
	        /**
	         * set a pointer to end of table length
	         * doing this rather than rebuilding an array for efficiency
	         * also so we don't need to reloop through entire data array
	         * since we know that the filters should be in order
	        */
	        var pointer = this.data.table.length - 1;
	
	        /**
	         * loop through each of the collapsed row names
	         * if the header row matches the collapsed row, then we need to collapse it
	        */
	        collapsedRows.forEach(function (rowValue) {
	          while (pointer >= 0) {
	            if (_this3.data.table[pointer].type === 'rowHeader' && rowValue === _this3.data.table[pointer].value[0]) {
	              _this3.collapse(pointer);
	              break;
	            }
	            pointer -= 1;
	          }
	        });
	      }
	
	      return this;
	    }
	  }]);
	  return Pivot;
	}(); /**
	      * @file Pivot class with methods
	     */
	
	
	exports.default = Pivot;
	module.exports = exports['default'];

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(3), __esModule: true };

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(4);
	module.exports = __webpack_require__(24).Object.keys;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(5)
	  , $keys    = __webpack_require__(7);
	
	__webpack_require__(22)('keys', function(){
	  return function keys(it){
	    return $keys(toObject(it));
	  };
	});

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(6);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(8)
	  , enumBugKeys = __webpack_require__(21);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(9)
	  , toIObject    = __webpack_require__(10)
	  , arrayIndexOf = __webpack_require__(13)(false)
	  , IE_PROTO     = __webpack_require__(17)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(11)
	  , defined = __webpack_require__(6);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(12);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(10)
	  , toLength  = __webpack_require__(14)
	  , toIndex   = __webpack_require__(16);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(15)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 15 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(15)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(18)('keys')
	  , uid    = __webpack_require__(20);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(19)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 20 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 21 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(23)
	  , core    = __webpack_require__(24)
	  , fails   = __webpack_require__(33);
	module.exports = function(KEY, exec){
	  var fn  = (core.Object || {})[KEY] || Object[KEY]
	    , exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(19)
	  , core      = __webpack_require__(24)
	  , ctx       = __webpack_require__(25)
	  , hide      = __webpack_require__(27)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 24 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(26);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 26 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(28)
	  , createDesc = __webpack_require__(36);
	module.exports = __webpack_require__(32) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(29)
	  , IE8_DOM_DEFINE = __webpack_require__(31)
	  , toPrimitive    = __webpack_require__(35)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(32) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(32) && !__webpack_require__(33)(function(){
	  return Object.defineProperty(__webpack_require__(34)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(33)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 33 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30)
	  , document = __webpack_require__(19).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(30);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(39);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(40), __esModule: true };

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(41);
	var $Object = __webpack_require__(24).Object;
	module.exports = function defineProperty(it, key, desc){
	  return $Object.defineProperty(it, key, desc);
	};

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(23);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(32), 'Object', {defineProperty: __webpack_require__(28).f});

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _values = __webpack_require__(49);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _keys = __webpack_require__(2);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(53);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(55);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _typeof2 = __webpack_require__(56);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	exports.fixDataFormat = fixDataFormat;
	exports.groupByCategory = groupByCategory;
	exports.groupByCategories = groupByCategories;
	exports.createColumnHeaders = createColumnHeaders;
	exports.accumulator = accumulator;
	exports.checkPivotCategories = checkPivotCategories;
	exports.tableCreator = tableCreator;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @file Contains logic to actually pivot data
	*/
	
	/**
	 * @description Format data into an array of objects where the headers are the keys
	 * @param {!Array|Object} data Array of arrays or an object
	 * @param {Function} custom sort function or default sort if null. Function equaling () => {} will skip the sort stage
	 * @returns {Array<Object>} Formatted object
	*/
	function fixDataFormat(data) {
	  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var sortFunc = arguments[2];
	
	  if (!Array.isArray(data) || !data.length) return [];
	
	  var formattedData = [];
	
	  if ((0, _typeof3.default)(data[0]) === 'object' && !Array.isArray(data[0])) {
	    formattedData = data;
	  } else {
	    formattedData = data.reduce(function (dataCol, row, i, arr) {
	      if (i !== 0) {
	        if (Array.isArray(row)) {
	          dataCol.push(row.reduce(function (acc, curr, index) {
	            acc[arr[0][index]] = curr;
	            return acc;
	          }, {}));
	        } else {
	          dataCol.push((0, _defineProperty3.default)({}, arr[0], row));
	        }
	      }
	      return dataCol;
	    }, []);
	  }
	
	  // sorting data initially to prevent changes in data ordering
	  if (rows.length > 0) {
	
	    // NoOp Sort function, return unsorted
	    if (sortFunc === function () {}) {
	      return formattedData;
	    }
	
	    // Use default sort if none provided
	    if (!sortFunc) {
	      sortFunc = function sortFunc(row) {
	        return function (a, b) {
	          return a[row] > b[row];
	        };
	      };
	    }
	
	    // Sort Rows
	    return rows.reduceRight(function (acc, row) {
	      return acc.sort(sortFunc(row));
	    }, formattedData);
	  }
	
	  return formattedData.sort(function (a, b) {
	    return (0, _stringify2.default)(a) > (0, _stringify2.default)(b);
	  });
	}
	
	/**
	 * @description Groups the data into an object by the provided category
	 * @param {!Array<Object>} data Array of objects
	 * @param {string} groupBy Category to group by
	 * @returns {Object} Each key in the object is one the category groups
	*/
	function groupByCategory(data, groupBy) {
	  return data.reduce(function (acc, curr) {
	    var category = curr[groupBy];
	
	    if (!acc[category]) acc[category] = [];
	    acc[category].push(curr);
	    return acc;
	  }, {});
	}
	
	/**
	 * @description Performs groupByCategory recursively (nesting objects within objects)
	 * @param {!Array<Object>} data Array of objects
	 * @param {Array} groups Items to categorize by
	 * @param {Object} acc The accumulated results
	 * @returns {Object} Deeply nested object
	 * where each key is one the category groups
	*/
	function groupByCategories(data) {
	  var groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  /**
	   * base case - if data is empty
	   * or if there are no more groups to group by
	   * return result
	  */
	  if (data.length === 0 || groups.length === 0) return data;
	
	  var groupedData = groupByCategory(data, groups[0]);
	  var groupedDataKeys = (0, _keys2.default)(groupedData);
	  var children = (0, _values2.default)(groupedData);
	
	  for (var i = 0; i < children.length; i++) {
	    acc[groupedDataKeys[i]] = groupByCategories(children[i], groups.slice(1), acc[groupedDataKeys[i]]);
	  }
	
	  return acc;
	}
	
	/**
	 * @description Builds the column headers and a map to each header
	 * @param {!Array<Object>} data Array of objects
	 * @param {Array} cols Columns to pivot on
	 * @param {string} firstColumn A string to place in the first column header
	 * @param {Function} columnSortFunc A sort function to sort the column headers
	 * @returns {Object} columnHeaders (array of arrays) and mapToHeader (object)
	*/
	function createColumnHeaders(data) {
	  var cols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var firstColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  var columnSortFunc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
	    return function () {};
	  };
	
	  if (cols.length === 0) {
	    return {
	      columnHeaders: [firstColumn],
	      mapToHeader: null
	    };
	  }
	
	  var mapToHeader = groupByCategories(data, cols);
	  var columnHeaders = [];
	  var mapPos = 1;
	
	  (function columnHeaderRecursion(data) {
	    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    var headerMap = arguments[2];
	
	    /** base case - at actual data as opposed to another grouping */
	    if ((typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) !== 'object' || Array.isArray(data)) return 1;
	
	    var currKeys = (0, _keys2.default)(data).sort(columnSortFunc(data, cols, pos));
	    var sumLength = 0;
	
	    for (var i = 0; i < currKeys.length; i++) {
	      var currLength = columnHeaderRecursion(data[currKeys[i]], pos + 1, headerMap[currKeys[i]]);
	
	      if (Array.isArray(data[currKeys[i]])) {
	        headerMap[currKeys[i]] = mapPos;
	        mapPos += 1;
	      }
	
	      columnHeaders[pos] = typeof columnHeaders[pos] === 'undefined' ? [firstColumn].concat(Array(currLength).fill(currKeys[i])) : columnHeaders[pos].concat(Array(currLength).fill(currKeys[i]));
	
	      sumLength += currLength;
	    }
	
	    return sumLength;
	  })(mapToHeader, 0, mapToHeader);
	
	  return {
	    columnHeaders: columnHeaders,
	    mapToHeader: mapToHeader
	  };
	}
	
	/**
	 * @description Reduces an array of values to a result
	 * @param {!Array} arr The array to reduce
	 * @param {?requestCallback|string} accCat Callback, category to reduce, or null
	 * @param {string} accType Reduce type (count, average, min, max, etc) or initial value
	 * @param {*} accValue Initial value - string, number, array, or object
	 * @returns {*} Reduced value
	 * @todo Move accumulator to its own file since it will continue to grow
	*/
	function accumulator(arr, accCat, accType, accValue) {
	  if (typeof accCat === 'undefined') accType = 'count';else if (typeof accCat === 'function') accValue = accType || 0;
	
	  return arr.reduce(function (acc, curr, index, array) {
	    if (typeof accCat === 'function') return accCat(acc, curr, index, array);
	
	    switch (accType) {
	      case 'average':
	        {
	          acc += Number(curr[accCat]) / arr.length;
	
	          return acc;
	        }
	
	      case 'count':
	        {
	          acc += 1;
	
	          return acc;
	        }
	
	      case 'min':
	        {
	          if (index === 0) acc = Number(curr[accCat]);else if (curr[accCat] < acc) acc = Number(curr[accCat]);
	
	          return acc;
	        }
	
	      case 'max':
	        {
	          if (index === 0) acc = Number(curr[accCat]);else if (curr[accCat] > acc) acc = Number(curr[accCat]);
	
	          return acc;
	        }
	
	      case 'sum':
	        {
	          acc += Number(curr[accCat]);
	
	          return acc;
	        }
	
	      default:
	        {
	          acc += 1;
	
	          return acc;
	        }
	    }
	  }, accValue || 0);
	}
	
	/**
	 * @description Check that categories to pivot on actually exist
	 * @param {!Object} actualCats Categories that actually exist in the data
	 * @param {!Array<string>} selectedCats Categories to pivot selected by user
	 * @throws Will throw an error if the category does not exist
	*/
	function checkPivotCategories(actualCats, selectedCats) {
	  var errMessage = selectedCats.filter(function (selectedCat) {
	    return !(selectedCat in actualCats);
	  });
	
	  if (errMessage.length > 0) {
	    throw new Error('Check that these selected pivot categories exist: ' + errMessage.join(', '));
	  }
	}
	
	function tableCreator(data) {
	  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var accCatOrCB = arguments[3];
	  var accTypeOrInitVal = arguments[4];
	  var rowHeader = arguments[5];
	  var columnSortFunc = arguments[6];
	
	
	  /** if data is empty, return empty array */
	  if (data.length === 0) {
	    return {
	      rawData: [],
	      table: []
	    };
	  };
	
	  /** if rows/cols are not arrays, return throw an error */
	  if (!Array.isArray(rows) || !Array.isArray(cols)) {
	    throw new Error('rowsToPivot and colsToPivot must be of type array');
	  }
	
	  checkPivotCategories(data[0], rows);
	  checkPivotCategories(data[0], cols);
	
	  if (typeof rowHeader === 'undefined') {
	    rowHeader = typeof accCatOrCB !== 'function' ? accTypeOrInitVal + ' ' + accCatOrCB : 'Custom Agg';
	  }
	
	  var columnData = createColumnHeaders(data, cols, rowHeader, columnSortFunc);
	  var columnHeaders = Array.isArray(columnData.columnHeaders[0]) ? columnData.columnHeaders : [columnData.columnHeaders.concat(rowHeader)];
	  var mapToHeader = columnData.mapToHeader;
	  var headerLength = columnHeaders[0].length;
	  var formattedColumnHeaders = columnHeaders.map(function (value, depth) {
	    return {
	      value: value,
	      depth: depth,
	      type: 'colHeader',
	      row: depth
	    };
	  });
	
	  var dataRows = [];
	  var rawData = [];
	  var prevKey = null;
	
	  function rowRecurse(rowGroups, depth) {
	    var rowHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    var _loop = function _loop(key) {
	      if (Array.isArray(rowGroups[key])) {
	        var recursedData = groupByCategories(rowGroups[key], cols);
	
	        prevKey = null;
	
	        (function recurseThroughMap(dataPos, map) {
	          if (Array.isArray(dataPos)) {
	            if (key === prevKey) {
	              var datum = dataRows[dataRows.length - 1].value;
	
	              datum[map] = accumulator(dataPos, accCatOrCB, accTypeOrInitVal);
	              dataRows[dataRows.length - 1].value = datum;
	
	              var rawDataDatum = rawData[rawData.length - 1].value;
	
	              rawDataDatum[map] = dataPos;
	              rawData[rawData.length - 1].value = rawDataDatum;
	            } else {
	              prevKey = key;
	              var _datum = [key].concat(Array(map - 1).fill(''), accumulator(dataPos, accCatOrCB, accTypeOrInitVal), Array(headerLength - (map + 1)).fill(''));
	              var _rawDataDatum = [key].concat(Array(map - 1).fill(''), [dataPos], Array(headerLength - (map + 1)).fill(''));
	
	              rawData.push({
	                value: _rawDataDatum,
	                type: 'data',
	                depth: depth
	              });
	              dataRows.push({
	                value: _datum,
	                type: 'data',
	                depth: depth,
	                row: dataRows.length + formattedColumnHeaders.length
	              });
	            }
	          } else {
	            for (var innerKey in dataPos) {
	              recurseThroughMap(dataPos[innerKey], map[innerKey]);
	            }
	          }
	        })(recursedData, mapToHeader || 1);
	      } else {
	        var rowHeaderValue = rowHeaders.shift();
	        var value = rowHeaderValue ? rowHeaderValue.value : [key].concat(Array(headerLength - 1).fill(''));
	
	        dataRows.push({
	          value: value,
	          depth: depth,
	          type: 'rowHeader',
	          row: dataRows.length + formattedColumnHeaders.length
	        });
	        rawData.push({
	          value: value,
	          depth: depth,
	          type: 'rowHeader'
	        });
	
	        rowRecurse(rowGroups[key], depth + 1, rowHeaders);
	      }
	    };
	
	    for (var key in rowGroups) {
	      _loop(key);
	    }
	  }
	
	  var dataGroups = [];
	
	  if (rows.length > 0) {
	    for (var i = 0; i < rows.length; i++) {
	      // possible memoization opportunity
	      rowRecurse(groupByCategories(data, rows.slice(0, i + 1)), 0, dataGroups);
	      dataGroups = (0, _assign2.default)([], dataRows);
	      if (i + 1 < rows.length) {
	        dataRows = [];
	        rawData = [];
	        prevKey = null;
	      }
	    }
	  } else if (cols.length > 0) {
	    for (var _i = 0; _i < cols.length; _i++) {
	      rowRecurse(groupByCategories(data, cols.slice(0, _i + 1)), 0, dataGroups);
	      dataGroups = (0, _assign2.default)([], dataRows);
	      if (_i + 1 < cols.length) {
	        dataRows = [];
	        rawData = [];
	        prevKey = null;
	      }
	    }
	  } else {
	    dataRows.push({
	      value: [rowHeader, accumulator(data, accCatOrCB, accTypeOrInitVal)],
	      type: 'data',
	      row: 1,
	      depth: 0
	    });
	    rawData = data.map(function (value) {
	      return {
	        value: value,
	        type: 0,
	        row: 1,
	        depth: 0
	      };
	    });
	  }
	
	  function tableRowAggregator(rows) {
	    var filteredRows = rows.reduce(function (acc, _ref) {
	      var type = _ref.type,
	          value = _ref.value;
	
	      if (acc.length === 0) {
	        acc = Array(value.length).fill([]);
	      }
	
	      if (type === 'data') {
	        value.forEach(function (valueElem, i) {
	          if (Array.isArray(valueElem)) {
	            acc[i] = acc[i].concat(valueElem);
	          }
	        });
	      }
	
	      return acc;
	    }, []);
	
	    return filteredRows.map(function (accumulatedRawData) {
	      if (accumulatedRawData.length > 0) {
	        return accumulator(accumulatedRawData, accCatOrCB, accTypeOrInitVal);
	      }
	
	      return 'Totals';
	    });
	  }
	
	  function tableColumnAggregator(rows) {
	    var filteredRows = rows.reduce(function (acc, _ref2) {
	      var type = _ref2.type,
	          value = _ref2.value;
	
	      if (type === 'data') {
	        var _i2 = acc.length;
	
	        acc[_i2] = [];
	        value.forEach(function (valueElem) {
	          if (Array.isArray(valueElem)) {
	            acc[_i2] = acc[_i2].concat(valueElem);
	          }
	        });
	      } else if (type === 0) {
	        // TODO: Investigate why type is coming up as 0
	        // happens when aggregating [] for rows and [] for cols
	        acc.push(value);
	      }
	
	      return acc;
	    }, []);
	
	    return filteredRows.map(function (accumulatedRawData) {
	      if (accumulatedRawData.length > 0) {
	        return accumulator(accumulatedRawData, accCatOrCB, accTypeOrInitVal);
	      }
	
	      return '';
	    });
	  }
	
	  var columnAggregations = tableColumnAggregator(rawData);
	  var accumulatedRows = {
	    value: tableRowAggregator(rawData),
	    type: 'aggregated'
	  };
	
	  var colHeadersValueCopies = formattedColumnHeaders.map(function (_ref3) {
	    var value = _ref3.value;
	
	    return (0, _assign2.default)([], value);
	  });
	  var colHeadersCopy = formattedColumnHeaders.map(function (colHeaderObj, i) {
	    var copy = (0, _assign2.default)({}, colHeaderObj);
	
	    copy.value = colHeadersValueCopies[i];
	    return copy;
	  });
	
	  var counter = 0;
	  var table = colHeadersCopy.concat(dataRows, accumulatedRows).map(function (tableRow, i) {
	    if (tableRow.type === 'data') {
	      tableRow.value = tableRow.value.concat(columnAggregations[counter]);
	      counter += 1;
	    } else {
	      tableRow.value = tableRow.value.concat(i === 0 ? 'Totals' : '');
	    }
	
	    return tableRow;
	  });
	
	  return {
	    table: table,
	    rawData: formattedColumnHeaders.concat(rawData)
	  };
	}

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(44), __esModule: true };

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(45);
	module.exports = __webpack_require__(24).Object.assign;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(23);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(46)});

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(7)
	  , gOPS     = __webpack_require__(47)
	  , pIE      = __webpack_require__(48)
	  , toObject = __webpack_require__(5)
	  , IObject  = __webpack_require__(11)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(33)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 47 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 48 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(50), __esModule: true };

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(51);
	module.exports = __webpack_require__(24).Object.values;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(23)
	  , $values = __webpack_require__(52)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it){
	    return $values(it);
	  }
	});

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(7)
	  , toIObject = __webpack_require__(10)
	  , isEnum    = __webpack_require__(48).f;
	module.exports = function(isEntries){
	  return function(it){
	    var O      = toIObject(it)
	      , keys   = getKeys(O)
	      , length = keys.length
	      , i      = 0
	      , result = []
	      , key;
	    while(length > i)if(isEnum.call(O, key = keys[i++])){
	      result.push(isEntries ? [key, O[key]] : O[key]);
	    } return result;
	  };
	};

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(54), __esModule: true };

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(24)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(39);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(57);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(77);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(58), __esModule: true };

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(59);
	__webpack_require__(72);
	module.exports = __webpack_require__(76).f('iterator');

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at  = __webpack_require__(60)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(61)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(15)
	  , defined   = __webpack_require__(6);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY        = __webpack_require__(62)
	  , $export        = __webpack_require__(23)
	  , redefine       = __webpack_require__(63)
	  , hide           = __webpack_require__(27)
	  , has            = __webpack_require__(9)
	  , Iterators      = __webpack_require__(64)
	  , $iterCreate    = __webpack_require__(65)
	  , setToStringTag = __webpack_require__(69)
	  , getPrototypeOf = __webpack_require__(71)
	  , ITERATOR       = __webpack_require__(70)('iterator')
	  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	  , FF_ITERATOR    = '@@iterator'
	  , KEYS           = 'keys'
	  , VALUES         = 'values';
	
	var returnThis = function(){ return this; };
	
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function(kind){
	    if(!BUGGY && kind in proto)return proto[kind];
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  };
	  var TAG        = NAME + ' Iterator'
	    , DEF_VALUES = DEFAULT == VALUES
	    , VALUES_BUG = false
	    , proto      = Base.prototype
	    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , $default   = $native || getMethod(DEFAULT)
	    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
	    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
	    , methods, key, IteratorPrototype;
	  // Fix native
	  if($anyNative){
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
	    if(IteratorPrototype !== Object.prototype){
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if(DEF_VALUES && $native && $native.name !== VALUES){
	    VALUES_BUG = true;
	    $default = function values(){ return $native.call(this); };
	  }
	  // Define iterator
	  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      values:  DEF_VALUES ? $default : getMethod(VALUES),
	      keys:    IS_SET     ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if(FORCED)for(key in methods){
	      if(!(key in proto))redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

/***/ },
/* 62 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(27);

/***/ },
/* 64 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create         = __webpack_require__(66)
	  , descriptor     = __webpack_require__(36)
	  , setToStringTag = __webpack_require__(69)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(27)(IteratorPrototype, __webpack_require__(70)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
	  setToStringTag(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject    = __webpack_require__(29)
	  , dPs         = __webpack_require__(67)
	  , enumBugKeys = __webpack_require__(21)
	  , IE_PROTO    = __webpack_require__(17)('IE_PROTO')
	  , Empty       = function(){ /* empty */ }
	  , PROTOTYPE   = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function(){
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(34)('iframe')
	    , i      = enumBugKeys.length
	    , lt     = '<'
	    , gt     = '>'
	    , iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(68).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties){
	  var result;
	  if(O !== null){
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty;
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var dP       = __webpack_require__(28)
	  , anObject = __webpack_require__(29)
	  , getKeys  = __webpack_require__(7);
	
	module.exports = __webpack_require__(32) ? Object.defineProperties : function defineProperties(O, Properties){
	  anObject(O);
	  var keys   = getKeys(Properties)
	    , length = keys.length
	    , i = 0
	    , P;
	  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(19).document && document.documentElement;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(28).f
	  , has = __webpack_require__(9)
	  , TAG = __webpack_require__(70)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
	};

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	var store      = __webpack_require__(18)('wks')
	  , uid        = __webpack_require__(20)
	  , Symbol     = __webpack_require__(19).Symbol
	  , USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function(name){
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has         = __webpack_require__(9)
	  , toObject    = __webpack_require__(5)
	  , IE_PROTO    = __webpack_require__(17)('IE_PROTO')
	  , ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function(O){
	  O = toObject(O);
	  if(has(O, IE_PROTO))return O[IE_PROTO];
	  if(typeof O.constructor == 'function' && O instanceof O.constructor){
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(73);
	var global        = __webpack_require__(19)
	  , hide          = __webpack_require__(27)
	  , Iterators     = __webpack_require__(64)
	  , TO_STRING_TAG = __webpack_require__(70)('toStringTag');
	
	for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
	  var NAME       = collections[i]
	    , Collection = global[NAME]
	    , proto      = Collection && Collection.prototype;
	  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(74)
	  , step             = __webpack_require__(75)
	  , Iterators        = __webpack_require__(64)
	  , toIObject        = __webpack_require__(10);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(61)(Array, 'Array', function(iterated, kind){
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');

/***/ },
/* 74 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 75 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(70);

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(78), __esModule: true };

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(79);
	__webpack_require__(88);
	__webpack_require__(89);
	__webpack_require__(90);
	module.exports = __webpack_require__(24).Symbol;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global         = __webpack_require__(19)
	  , has            = __webpack_require__(9)
	  , DESCRIPTORS    = __webpack_require__(32)
	  , $export        = __webpack_require__(23)
	  , redefine       = __webpack_require__(63)
	  , META           = __webpack_require__(80).KEY
	  , $fails         = __webpack_require__(33)
	  , shared         = __webpack_require__(18)
	  , setToStringTag = __webpack_require__(69)
	  , uid            = __webpack_require__(20)
	  , wks            = __webpack_require__(70)
	  , wksExt         = __webpack_require__(76)
	  , wksDefine      = __webpack_require__(81)
	  , keyOf          = __webpack_require__(82)
	  , enumKeys       = __webpack_require__(83)
	  , isArray        = __webpack_require__(84)
	  , anObject       = __webpack_require__(29)
	  , toIObject      = __webpack_require__(10)
	  , toPrimitive    = __webpack_require__(35)
	  , createDesc     = __webpack_require__(36)
	  , _create        = __webpack_require__(66)
	  , gOPNExt        = __webpack_require__(85)
	  , $GOPD          = __webpack_require__(87)
	  , $DP            = __webpack_require__(28)
	  , $keys          = __webpack_require__(7)
	  , gOPD           = $GOPD.f
	  , dP             = $DP.f
	  , gOPN           = gOPNExt.f
	  , $Symbol        = global.Symbol
	  , $JSON          = global.JSON
	  , _stringify     = $JSON && $JSON.stringify
	  , PROTOTYPE      = 'prototype'
	  , HIDDEN         = wks('_hidden')
	  , TO_PRIMITIVE   = wks('toPrimitive')
	  , isEnum         = {}.propertyIsEnumerable
	  , SymbolRegistry = shared('symbol-registry')
	  , AllSymbols     = shared('symbols')
	  , OPSymbols      = shared('op-symbols')
	  , ObjectProto    = Object[PROTOTYPE]
	  , USE_NATIVE     = typeof $Symbol == 'function'
	  , QObject        = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function(){
	  return _create(dP({}, 'a', {
	    get: function(){ return dP(this, 'a', {value: 7}).a; }
	  })).a != 7;
	}) ? function(it, key, D){
	  var protoDesc = gOPD(ObjectProto, key);
	  if(protoDesc)delete ObjectProto[key];
	  dP(it, key, D);
	  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function(tag){
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
	  return typeof it == 'symbol';
	} : function(it){
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D){
	  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if(has(AllSymbols, key)){
	    if(!D.enumerable){
	      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
	      D = _create(D, {enumerable: createDesc(0, false)});
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P){
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P))
	    , i    = 0
	    , l = keys.length
	    , key;
	  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P){
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key){
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
	  it  = toIObject(it);
	  key = toPrimitive(key, true);
	  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
	  var D = gOPD(it, key);
	  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it){
	  var names  = gOPN(toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
	  var IS_OP  = it === ObjectProto
	    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
	    , result = []
	    , i      = 0
	    , key;
	  while(names.length > i){
	    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if(!USE_NATIVE){
	  $Symbol = function Symbol(){
	    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function(value){
	      if(this === ObjectProto)$set.call(OPSymbols, value);
	      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f   = $defineProperty;
	  __webpack_require__(86).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(48).f  = $propertyIsEnumerable;
	  __webpack_require__(47).f = $getOwnPropertySymbols;
	
	  if(DESCRIPTORS && !__webpack_require__(62)){
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function(name){
	    return wrap(wks(name));
	  }
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
	for(var symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
	for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function(key){
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(key){
	    if(isSymbol(key))return keyOf(SymbolRegistry, key);
	    throw TypeError(key + ' is not a symbol!');
	  },
	  useSetter: function(){ setter = true; },
	  useSimple: function(){ setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it){
	    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
	    var args = [it]
	      , i    = 1
	      , replacer, $replacer;
	    while(arguments.length > i)args.push(arguments[i++]);
	    replacer = args[1];
	    if(typeof replacer == 'function')$replacer = replacer;
	    if($replacer || !isArray(replacer))replacer = function(key, value){
	      if($replacer)value = $replacer.call(this, key, value);
	      if(!isSymbol(value))return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(27)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var META     = __webpack_require__(20)('meta')
	  , isObject = __webpack_require__(30)
	  , has      = __webpack_require__(9)
	  , setDesc  = __webpack_require__(28).f
	  , id       = 0;
	var isExtensible = Object.isExtensible || function(){
	  return true;
	};
	var FREEZE = !__webpack_require__(33)(function(){
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function(it){
	  setDesc(it, META, {value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  }});
	};
	var fastKey = function(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add metadata
	    if(!create)return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function(it, create){
	  if(!has(it, META)){
	    // can't set metadata to uncaught frozen object
	    if(!isExtensible(it))return true;
	    // not necessary to add metadata
	    if(!create)return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function(it){
	  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY:      META,
	  NEED:     false,
	  fastKey:  fastKey,
	  getWeak:  getWeak,
	  onFreeze: onFreeze
	};

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var global         = __webpack_require__(19)
	  , core           = __webpack_require__(24)
	  , LIBRARY        = __webpack_require__(62)
	  , wksExt         = __webpack_require__(76)
	  , defineProperty = __webpack_require__(28).f;
	module.exports = function(name){
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var getKeys   = __webpack_require__(7)
	  , toIObject = __webpack_require__(10);
	module.exports = function(object, el){
	  var O      = toIObject(object)
	    , keys   = getKeys(O)
	    , length = keys.length
	    , index  = 0
	    , key;
	  while(length > index)if(O[key = keys[index++]] === el)return key;
	};

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(7)
	  , gOPS    = __webpack_require__(47)
	  , pIE     = __webpack_require__(48);
	module.exports = function(it){
	  var result     = getKeys(it)
	    , getSymbols = gOPS.f;
	  if(getSymbols){
	    var symbols = getSymbols(it)
	      , isEnum  = pIE.f
	      , i       = 0
	      , key;
	    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
	  } return result;
	};

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(12);
	module.exports = Array.isArray || function isArray(arg){
	  return cof(arg) == 'Array';
	};

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(10)
	  , gOPN      = __webpack_require__(86).f
	  , toString  = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function(it){
	  try {
	    return gOPN(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it){
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys      = __webpack_require__(8)
	  , hiddenKeys = __webpack_require__(21).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
	  return $keys(O, hiddenKeys);
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var pIE            = __webpack_require__(48)
	  , createDesc     = __webpack_require__(36)
	  , toIObject      = __webpack_require__(10)
	  , toPrimitive    = __webpack_require__(35)
	  , has            = __webpack_require__(9)
	  , IE8_DOM_DEFINE = __webpack_require__(31)
	  , gOPD           = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(32) ? gOPD : function getOwnPropertyDescriptor(O, P){
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if(IE8_DOM_DEFINE)try {
	    return gOPD(O, P);
	  } catch(e){ /* empty */ }
	  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
	};

/***/ },
/* 88 */
/***/ function(module, exports) {



/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(81)('asyncIterator');

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(81)('observable');

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.collapse = collapse;
	exports.expand = expand;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @file Utility functions for collapsing and expanding functionality
	*/
	
	/**
	 * Collapse a row given a row number and the data
	 * @param {number} rowNum
	 * @param {Array<Object>} data
	 * @returns {Object}
	*/
	function collapse(rowNum, data) {
	  /** get the current row, row type, and row depth */
	  var selectedRow = data.table[rowNum];
	  var type = selectedRow.type,
	      depth = selectedRow.depth;
	
	  /** if row is not a header, it is not collapsable*/
	
	  if (type !== 'rowHeader' && type !== 'colHeader') {
	    return {
	      uncollapsed: data
	    };
	  }
	
	  var count = rowNum + 1;
	  var currDepth = data.table[count].depth;
	
	  /** any row above the row to collapse (including the row itself) can not collapse into the row */
	  var uncollapsed = {
	    table: data.table.slice(0, count),
	    rawData: data.rawData.slice(0, count)
	  };
	
	  var collapsed = {
	    table: [],
	    rawData: []
	  };
	
	  /**
	   * while count is less than the number of rows
	   * or while the current row is deeper than the row we are collapsing into
	  */
	  while (count < data.table.length && currDepth > depth) {
	    /** roll data in collapsed state and advance pointer */
	    collapsed.rawData.push(data.rawData[count]);
	    collapsed.table.push(data.table[count]);
	    count += 1;
	    /** update the current depth */
	    if (count < data.table.length) currDepth = data.table[count].depth;
	  }
	
	  /** remaining rows are not collapsed */
	  uncollapsed.table = uncollapsed.table.concat(data.table.slice(count));
	  uncollapsed.rawData = uncollapsed.rawData.concat(data.rawData.slice(count));
	
	  return {
	    uncollapsed: uncollapsed,
	    collapsed: collapsed
	  };
	}
	
	/**
	 * Expand a row given a row number, the current data, and the current collapsed rows
	 * @param {number} rowNum
	 * @param {Array<Object>} currData
	 * @param {Object} collapsedRows
	 * @returns {Object}
	*/
	function expand(rowNum, currData, collapsedRows) {
	  var _currData$table, _currData$rawData;
	
	  /** if there are no collapsed rows, then just return data */
	  if (!collapsedRows) return currData;
	
	  /** splicing the collapsed rows back onto the data table */
	  (_currData$table = currData.table).splice.apply(_currData$table, [rowNum + 1, 0].concat((0, _toConsumableArray3.default)(collapsedRows.table)));
	  (_currData$rawData = currData.rawData).splice.apply(_currData$rawData, [rowNum + 1, 0].concat((0, _toConsumableArray3.default)(collapsedRows.rawData)));
	
	  return currData;
	}

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(93);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(59);
	__webpack_require__(95);
	module.exports = __webpack_require__(24).Array.from;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx            = __webpack_require__(25)
	  , $export        = __webpack_require__(23)
	  , toObject       = __webpack_require__(5)
	  , call           = __webpack_require__(96)
	  , isArrayIter    = __webpack_require__(97)
	  , toLength       = __webpack_require__(14)
	  , createProperty = __webpack_require__(98)
	  , getIterFn      = __webpack_require__(99);
	
	$export($export.S + $export.F * !__webpack_require__(101)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike)
	      , C       = typeof this == 'function' ? this : Array
	      , aLen    = arguments.length
	      , mapfn   = aLen > 1 ? arguments[1] : undefined
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for(result = new C(length); length > index; index++){
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(29);
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch(e){
	    var ret = iterator['return'];
	    if(ret !== undefined)anObject(ret.call(iterator));
	    throw e;
	  }
	};

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators  = __webpack_require__(64)
	  , ITERATOR   = __webpack_require__(70)('iterator')
	  , ArrayProto = Array.prototype;
	
	module.exports = function(it){
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(28)
	  , createDesc      = __webpack_require__(36);
	
	module.exports = function(object, index, value){
	  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var classof   = __webpack_require__(100)
	  , ITERATOR  = __webpack_require__(70)('iterator')
	  , Iterators = __webpack_require__(64);
	module.exports = __webpack_require__(24).getIteratorMethod = function(it){
	  if(it != undefined)return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(12)
	  , TAG = __webpack_require__(70)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function(it, key){
	  try {
	    return it[key];
	  } catch(e){ /* empty */ }
	};
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR     = __webpack_require__(70)('iterator')
	  , SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	
	module.exports = function(exec, skipClosing){
	  if(!skipClosing && !SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[ITERATOR]();
	    iter.next = function(){ return {done: safe = true}; };
	    arr[ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(2);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.createUniqueValues = createUniqueValues;
	exports.filter = filter;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @file Utility functions for filtering functionality
	*/
	
	/**
	 * Construct an object of field names with the unique values for each field
	 * @param {!Array<Object>} data
	 * @returns {!Object} Keys are field names, each value is an object with the unique values as keys
	*/
	function createUniqueValues(data) {
	  return data.reduce(function (acc, curr) {
	    (0, _keys2.default)(curr).forEach(function (fieldName) {
	      if (!acc[fieldName]) acc[fieldName] = {};
	      /** by using an object instead of an array, we avoid extra work checking the array for duplicates*/
	      acc[fieldName][curr[fieldName]] = true;
	    });
	
	    return acc;
	  }, {});
	};
	
	/**
	 * Filter a provided data set
	 * @param {!Array<Object>} data
	 * @param {string|function} fieldName Callback function or a field name
	 * @param {Array<string>} filterValues Values to perform filter on
	 * @param {string} filterType Enumerated string either 'include' or 'exclude'
	 * @returns {!Array<Object>} filtered data set
	*/
	function filter(data, fieldName, filterValues, filterType) {
	  /** check that fieldName isn't actually a callback */
	  if (typeof fieldName !== 'function') {
	    /** filter out the data set based on the provided fieldName and filterValues */
	    return data.filter(function (_ref) {
	      var value = _ref[fieldName];
	
	      switch (filterType) {
	        case 'include':
	          {
	            return filterValues.indexOf(value) !== -1;
	          }
	
	        case 'exclude':
	          {
	            return filterValues.indexOf(value) === -1;
	          }
	
	        default:
	          {
	            return filterValues.indexOf(value) === -1;
	          }
	      }
	    });
	  }
	
	  /** if custom callback provided, filter using the callback */
	  return data.filter(function (dataRow, index, array) {
	    return fieldName(dataRow, index, array);
	  });
	};

/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** quick-pivot.min.js
 **/